import { mergeClasses } from '@/utils';

import { BlankCircleIcon, FilledCheckCircleIcon } from '@/assets/icons';

import { PASSWORD_RULES_WITH_LABELS } from '@/features/auth/constants';
import { isValidPassword } from '@/features/auth/utils';

interface IPasswordConstraints {
  password: string;
  isFocused: boolean;
  isFirstTime?: boolean;
  showErrors?: boolean;
}

export const PasswordConstraints = ({
  password,
  isFocused,
  showErrors = true,
  isFirstTime = false,
}: IPasswordConstraints) => {
  if (!password) return null;

  return (
    <div className="mt-2">
      {isFirstTime && (
        <p className="text-body-xs font-medium mb-1 text-neutral-0">
          New password must not match any of your last 8 passwords.
        </p>
      )}
      <p
        className={mergeClasses(
          'text-body-xs font-medium mb-1',
          isValidPassword(password)
            ? 'text-neutral-0'
            : showErrors && !isFocused
            ? 'text-red-base'
            : 'text-neutral-0',
        )}
      >
        Password must contain at least:
      </p>
      <ul className="space-y-1">
        {PASSWORD_RULES_WITH_LABELS.map((rule, index) => (
          <li
            key={index}
            className={mergeClasses(
              'flex items-center gap-2 text-body-xs font-medium',
              rule.test(password)
                ? 'text-semantic-success-base'
                : showErrors && !isFocused
                ? 'text-red-base'
                : 'text-neutral-0',
            )}
          >
            {rule.test(password) ? (
              <FilledCheckCircleIcon className="flex-shrink-0" />
            ) : (
              <BlankCircleIcon
                className="w-4 h-4 flex-shrink-0"
                isError={showErrors && !isFocused}
              />
            )}
            <span
              className={
                rule.test(password)
                  ? 'text-semantic-success-base'
                  : showErrors && !isFocused
                  ? 'text-red-base'
                  : 'text-neutral-0'
              }
            >
              {rule.label}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};
